import { styled } from '@mui/material/styles';

export const UnCheckedboxIcon = styled('span')(({ theme, width, height }) => ({
  borderRadius: 5,
  width: width || 30,
  height: height || 30,
  border: `1px solid ${theme.palette.primary.gray25}`,
  backgroundColor: theme.palette.primary.white,
  boxSizing: 'border-box',

  'input:hover ~ &': {
    border: `1px solid ${theme.palette.primary.darkBlue90}`,
  },
  'input:disabled ~ &': {
    border: `1px solid ${theme.palette.primary.gray25}`,
  },
}));
